import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import moment from 'moment';
import NumericLabel from 'react-pretty-numbers';
import { displayDateFormatShort } from '../../../constants';
import { trackActivity } from '../../../utils/mixpanel';

const SummaryPartialPaymentItemModal = ({ modal, data, currency, onClose }) => {
    if (!modal) return null;

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: 'View Summary Partial Payment', page_type })
    }

    const hasPaymentNo = Boolean(data?.payment_no);

    return (
        <Dialog aria-labelledby="summary-pp-dialog-title" className="add-lease-dialog" maxWidth="md" fullWidth open={true}>
            <DialogTitle sx={{ m: 0, p: 1, pl: 3 }} className="dialog-header" id="summary-pp-dialog-title">
                View Partial Payment Details
                <div>
                    <Typography variant="caption" sx={{ fontSize: '13px' }}>
                        Payment Date: {data?.payment_date ? moment(data.payment_date).format(displayDateFormatShort) : '--'}
                    </Typography>
                </div>
            </DialogTitle>
            <DialogContent dividers sx={{ pb: 1 }}>
                <TableContainer className="lease-detail-table" component={Paper}>
                    <Table className="mui-table-format" stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ minWidth: '160px' }}>Description</TableCell>
                                {hasPaymentNo && <TableCell sx={{ minWidth: '120px' }}>Payment No</TableCell>}
                                <TableCell align="center" sx={{ minWidth: '120px' }}>Paid Amount</TableCell>
                                <TableCell align="right" sx={{ minWidth: '140px' }}>Remaining Amount</TableCell>
                                <TableCell sx={{ minWidth: '120px' }}>Updated By</TableCell>
                                <TableCell sx={{ minWidth: '140px' }}>Last Updated</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell>{data?.description || '--'}</TableCell>
                                {hasPaymentNo && <TableCell>{data.payment_no}</TableCell>}
                                <TableCell align="center">
                                    <NumericLabel params={{ locales: 'en-GB', currency: true, currencyIndicator: currency, precision: 2, commafy: true, justification: 'L' }}>
                                        {data?.amount || 0}
                                    </NumericLabel>
                                </TableCell>
                                <TableCell align="right">
                                    <NumericLabel params={{ locales: 'en-GB', currency: true, currencyIndicator: currency, precision: 2, commafy: true, justification: 'L' }}>
                                        {data?.remaining_amount || 0}
                                    </NumericLabel>
                                </TableCell>
                                <TableCell>{data?.user?.name || '--'}</TableCell>
                                <TableCell>
                                    {data?.last_updated_at ? moment(data.last_updated_at).format(`${displayDateFormatShort} HH:mm`) : '--'}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
                <div style={{ color: '#00000073', textAlign: 'right', marginTop: '5px' }}>
                    Paid Amount:&nbsp;
                    <NumericLabel params={{ locales: 'en-GB', currency: true, currencyIndicator: currency, commafy: true, precision: 2, justification: 'L' }}>
                        {data?.amount || '0.00'}
                    </NumericLabel>
                </div>
            </DialogContent>
            <DialogActions sx={{ marginRight: '15px' }}>
                <Button className="cancel-btn" variant="outlined" size="small" onClick={() => { onClose(); handleItemClicked('Close Button') }}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SummaryPartialPaymentItemModal;
